import { render } from "./datatable.vue?vue&type=template&id=508b4f3e&scoped=true"
import script from "./datatable.vue?vue&type=script&lang=js"
export * from "./datatable.vue?vue&type=script&lang=js"

import "./datatable.vue?vue&type=style&index=0&id=508b4f3e&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/mFokeeiy/0/bpavone/detect-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508b4f3e"]])

export default __exports__